import emitterDataConfigApi from '@/api/config/emitterDataConfig'
import { queryKeys } from '@/constant/common'
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteEmitter(interfaceId: string, id: string): Promise<void> {
  await emitterDataConfigApi.delete(interfaceId, id)
}

function useDeleteEmitter(): UseMutateFunction<void, unknown, any, unknown> {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  const { mutate } = useMutation(
    (payload: any) => deleteEmitter(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.emitter])
        toast.success(t('deleteEmitterSuccess'))
        closeModal()
      },
      onError: (error: AxiosError<any>) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  return mutate
}

export default useDeleteEmitter
